export const PINNED_LAYER_SUFFIX: string = '-pinned-layer'
export const BACKGROUND_LAYER_SUFFIX: string = '-background-layer'
export const RESPONSIVE_PAGE_CONTAINER_PREFIX: string = 'Container'
export const SECTIONS_CONTAINER_PREFIX: string = 'PAGE_SECTIONS'
export const MASTER_PAGE_COMPONENTS_IN_RESPONSIVE = [
	'masterPage',
	'SITE_PAGES',
	'SITE_HEADER',
	'SITE_FOOTER',
	'PAGES_CONTAINER',
]
/** Master page components the editor keeps in a responsive site's structure; the rest are section templates. */
export const MASTER_PAGE_STRUCTURE_COMPONENTS_IN_RESPONSIVE = [
	...MASTER_PAGE_COMPONENTS_IN_RESPONSIVE,
	'BACKGROUND_GROUP',
	'SCROLL_TO_BOTTOM',
	'SCROLL_TO_TOP',
	'SKIP_TO_CONTENT_BTN',
	'WIX_ADS',
	'SOSP_CONTAINER_CUSTOM_ID',
	'SOSP_CONTAINER_CUSTOM_ID_relative',
]
// dom-id-usage-check-ignore-next-line -- selector-text parity with the Catharsis CSS emitters holding the same literal in id form (responsiveLayoutDomApplier.ts:11, landingPageCssDomApplier.ts:5); both must agree at runtime
export const SITE_CONTAINER_WITHOUT_HEADER_SELECTOR = '#masterPage.landingPage'
// dom-id-usage-check-ignore-next-line -- selector-text parity with the Catharsis CSS emitter holding the same literal in id form (responsiveLayoutDomApplier.ts:12); both must agree at runtime
export const SITE_CONTAINER_WITH_HEADER_SELECTOR = '#masterPage:not(.landingPage)'
export const INTERACT_ELEMENT_SELECTOR = 'interact-element'
export const TRIGGERS_AND_REACTIONS_NAME = 'triggersAndReactions' as const
